module.exports = __webpack_public_path__ + "img/jonahs-art.898585f6.jpg";